module.exports = __webpack_public_path__ + "img/cloudforest@2x.3481d39.webp";